import {
  Avatar,
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialButton from "../../../../../components/MaterialButton";
import MaterialInput from "../../../../../components/MaterialInput";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { FaRegComments } from "react-icons/fa";
import { CiCircleMore } from "react-icons/ci";
import { IoSend } from "react-icons/io5";
import SearchIcon from "@mui/icons-material/Search";
import Details from "./components/Details";
import axios from "axios";
import {
  BASE_URL,
  deleteData,
  fetchData,
  postData,
} from "../../../../Utils/Baseurl";
import { useAuth } from "../../../../../context/AuthContext";
import SubtaskAddForm from "./components/SubtaskAddForm";
import noTask from "../../../../../assest/noTaskImage.svg";
import ActivitySection from "./components/ActivitySection";
import Swal from "sweetalert2";
import { useSnackbar } from "../../../../../components/SnackbarProvider";
import { useLoading } from "../../../../../context/loadingcontext";
import CloseIcon from "@mui/icons-material/Close";
import ConfirmDialog from "../../../../../components/ReusableComponent/ConfirmDialog";

const TaskView = ({ taskData, fetchTaskDetails }) => {
  const { currentUser } = useAuth();
  const [value, setValue] = useState(
    taskData?.subtasks?.filter((subtask) => subtask.status === "Completed")
      .length || 0
  );
  const [editid, setEditid] = useState(0);
  const [subtaskdata, setsubtaskdata] = useState([]);
  const [subtaskDialogOpen, setSubtaskDialogOpen] = useState(false);
  const [editdata, setEditdata] = useState(false);
  const [view, setView] = useState(false);
  const [stakeholderdata, setStakeholderdata] = useState([]);
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const data = taskData;
  const [subTask, setSubTask] = useState({
    subTaskName: "",
    description: "",
    assignee: "",
    teams: "",
    stackholder: [],
    hours: "",
    startDate: "",
    endDate: "",
    attachments: [],
    subTaskNameStatus: "unchecked",
    descriptionStatus: "unchecked",
    assigneeStatus: "unchecked",
    hoursStatus: "unchecked",
    stackholderStatus: "unchecked",
    teamsStatus: "unchecked",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState([]);
  const [commentsinput, setCommentsinput] = useState("");
  const [projectcommentid, setProjectcommentid] = useState(0);
  const [projectid, setprojectid] = useState(0);
  const [opencomment, setOpencomment] = useState(false);
  const [expandedComments, setExpandedComments] = useState({});
  const [expandedReplies, setExpandedReplies] = useState({});

  console.log(comments, "comments");

  useEffect(() => {
    if (projectcommentid !== 0) {
      fetchCommentlist();
    }
  }, [projectcommentid]);

  const fetchCommentlist = async () => {
    setCirleLoading(true);
    try {
      const res = await fetchData(`api/tasks/${projectcommentid}/comments/`);
      console.log(res, "res");
      setComments(res.data);
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    console.log("data", data);
    setsubtaskdata(data);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialogComment = () => {
    setOpencomment(false);
    setProjectcommentid(0);
    setComments([]);
  };

  const handleView = (data) => {
    setSubtaskDialogOpen(true);
    setEditid(data.id);
    setEditdata(true);
    setView(true);
    DatasetforEdit(data);
    handleClose();
  };

  const handleEdit = (data) => {
    setSubtaskDialogOpen(true);
    setEditid(data.id);
    setEditdata(true);
    DatasetforEdit(data);
    handleClose();
  };

  const DatasetforEdit = (data) => {
    setSubTask({
      subTaskName: data.task_title,
      description: data.task_describtion,
      teams: { value: data.teams, label: data.team_name },
      assignee: { value: data.Assignee, label: data.assignee_name },
      hours: data.assigned_hours,
      startDate: data.start_date,
      endDate: data.end_date,
      attachments: data.attachment === null ? [] : data.attachment,
      subTaskNameStatus: "success",
      descriptionStatus: "success",
      assigneeStatus: "success",
      hoursStatus: "success",
      teamsStatus: "success",
      startDateStatus: "success",
      endDateStatus: "success",
    });
    setStakeholderdata(data.stake_holder);
  };

  const handleDelete = async (data) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this task?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      setCirleLoading(true);
      try {
        const response = await deleteData(`api/taskcreation/${data.id}/`);
        if (response.status) {
          showSnackbar(response?.message, "success");
          fetchTaskDetails();
        } else {
          showSnackbar(response?.message, "error");
        }
      } catch (error) {
        let message = "An unexpected error occurred";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
          fetchTaskDetails();
        } else if (error?.message) {
          message = error.message;
        }

        showSnackbar(message, "error");
      } finally {
        setCirleLoading(false);
      }
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogData({
      title: "",
      content: "",
      onConfirm: () => {},
    });
  };

  const handleSubtaskDialog = () => {
    setSubtaskDialogOpen(true);
  };

  const handleCloseSubtaskDialog = () => {
    setSubtaskDialogOpen(false);
    setSubTask({
      subTaskName: "",
      description: "",
      assignee: "",
      teams: "",
      stackholder: [],
      startDate: "",
      endDate: "",
      attachments: [],
      subTaskNameStatus: "unchecked",
      descriptionStatus: "unchecked",
      assigneeStatus: "unchecked",
      teamsStatus: "unchecked",
      stackholderStatus: "unchecked",
      startDateStatus: "unchecked",
      endDateStatus: "unchecked",
    });
    setEditid(0);
    setView(false);
    setEditdata(false);
    fetchTaskDetails();
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      subTask.subTaskNameStatus === "success" &&
      subTask.descriptionStatus === "success" &&
      subTask.assigneeStatus === "success" &&
      subTask.hoursStatus === "success" &&
      subTask.teamsStatus === "success" &&
      subTask.startDateStatus === "success" &&
      subTask.endDateStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddSubtask = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const newId = subTask?.stackholder?.map((v) => ({
        user_id: v.id,
      }));
      const formData = new FormData();
      formData.append("task_title", subTask.subTaskName);
      formData.append("task_describtion", subTask.description);
      formData.append("start_date", subTask.startDate);
      formData.append("end_date", subTask.endDate);
      formData.append("teams", subTask?.teams?.label);
      formData.append("stake_holder", JSON.stringify(newId));
      formData.append("assigned_hours", subTask.hours);
      formData.append("Assignee_id", subTask.assignee.value);
      formData.append("task_creater_id", currentUser?.id);
      formData.append("priority_level", taskData.priority_level);
      formData.append("milestone_id", taskData.milestone);
      formData.append("module", taskData.module);
      formData.append("project_id", taskData?.project);
      formData.append("parent_id", taskData.id);
      if (!subTask.attachments.includes("task_attachments")) {
        if (subTask.attachments && subTask.attachments.length > 0) {
          subTask.attachments.forEach((file) => {
            formData.append("attachment", file);
          });
        }
      }
      if (editid === 0) {
        console.log("fd");
        const response = await axios.post(
          `${BASE_URL}api/taskcreation/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        console.log("fdewdrfrd");
        const response = await axios.put(
          `${BASE_URL}api/taskcreation/${editid}/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseSubtaskDialog();
    }
  };

  const onComment = (id, value) => {
    console.log("value", value);
    setOpencomment(true);
    setProjectcommentid(id);
    setprojectid(value.project);
  };

  const sendComment = () => {
    setDialogOpen(true);
    setDialogData({
      title: "Are you sure to you want to post this comment?",
      content: "",
      onConfirm: Commentsubmit,
    });
  };

  const Commentsubmit = async () => {
    setIsLoading(true);
    let datas = {
      project: projectid,
      comment_text: commentsinput,
      ...(comments.length > 0 && { parent: comments[0].id }),
    };

    try {
      const data = await postData(
        `api/tasks/${projectcommentid}/comments/`,
        datas
      );

      if (data?.status) {
        handleCloseDialog();
        showSnackbar("Comment added Sucessfully", "success");
        setCommentsinput("");
        fetchCommentlist();
      } else {
        setComments([]);
      }
    } catch (error) {
      let message = "An unexpected error occurred";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }
      showSnackbar(message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const renderText = (text, expanded, onToggle) => {
    if (text.length <= 100) return text;

    if (expanded) {
      return (
        <>
          {text}{" "}
          <Box
            component="span"
            onClick={onToggle}
            sx={{ color: "blue", cursor: "pointer", userSelect: "none" }}
          >
            Read less
          </Box>
        </>
      );
    } else {
      return (
        <>
          {text.substring(0, 100)}...{" "}
          <Box
            component="span"
            onClick={onToggle}
            sx={{ color: "blue", cursor: "pointer", userSelect: "none" }}
          >
            Read more
          </Box>
        </>
      );
    }
  };

  const handleComment = (e) => {
    setCommentsinput(e.target.value);
  };

  const toggleCommentExpand = (index) => {
    setExpandedComments((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleReplyExpand = (commentIndex, replyIndex) => {
    const key = `${commentIndex}-${replyIndex}`;
    setExpandedReplies((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <>
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <MaterialTypography
            variant="subtitle1"
            color="dark"
            fontWeight="bold"
          >
            {taskData.task_title}
          </MaterialTypography>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Stack direction="column" spacing={1}>
            <MaterialTypography
              variant="caption"
              color="text"
              fontWeight="bold"
            >
              Description
            </MaterialTypography>
            <MaterialTypography variant="caption" color="text">
              {taskData.task_describtion}
            </MaterialTypography>
          </Stack>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={2} mb={1}>
        <Grid size={{ xs: 6, sm: 6, md: 6 }}>
          <MaterialTypography variant="caption" color="text" fontWeight="bold">
            Sub-Tasks
          </MaterialTypography>
        </Grid>
        <Grid
          size={{ xs: 6, sm: 6, md: 6 }}
          display="flex"
          justifyContent="flex-end"
        >
          {/* <IconButton onClick={handleSubtaskDialog}>
                        <PlaylistAddRoundedIcon />
                    </IconButton> */}
          <MaterialButton
            variant="outlined"
            color="dark"
            size="small"
            // startIcon={<PlaylistAddRoundedIcon />}
            onClick={handleSubtaskDialog}
          >
            Add
          </MaterialButton>
        </Grid>
      </Grid>

      {taskData?.subtasks && taskData?.subtasks?.length > 0 ? (
        <>
          <Grid container spacing={2} mb={1}>
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
              <Box display="flex" alignItems="center" width="100%">
                <Box
                  sx={{
                    width: "100%",
                    height: 8,
                    borderRadius: 5,
                    display: "flex",
                    overflow: "hidden",
                    mr: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: `${value}%`,
                      backgroundColor: "#689f38",
                      transition: "width 0.3s ease",
                    }}
                  />
                  <Box
                    sx={{
                      width: `${100 - value}%`,
                      backgroundColor: "#4285f4",
                      transition: "width 0.3s ease",
                    }}
                  />
                </Box>
                <MaterialTypography variant="caption" color="text">
                  {`${value}% Done`}
                </MaterialTypography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={1} mb={2}>
            {taskData?.subtasks &&
              taskData?.subtasks.map((item, index) => (
                <Grid size={{ xs: 12 }}>
                  <Card
                    sx={{ p: 1, backgroundColor: "#f5f5f5", borderRadius: 2 }}
                  >
                    <Grid container spacing={1}>
                      <Grid size={{ xs: 6 }}>
                        <Stack direction="column" spacing={0}>
                          <MaterialTypography
                            variant="h6"
                            color="dark"
                            fontWeight="bold"
                            sx={{ fontSize: "0.80rem" }}
                          >
                            {item.task_title}
                          </MaterialTypography>
                          <MaterialTypography variant="caption" color="text">
                            {item.task_code}
                          </MaterialTypography>
                        </Stack>
                      </Grid>

                      <Grid
                        size={{ xs: 6 }}
                        display="flex"
                        justifyContent="flex-end"
                        alignItems="center"
                      >
                        <Stack direction="row" spacing={1}>
                          <Box
                            width="auto"
                            height="20px"
                            p={1}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="4px"
                            bgcolor={
                              item.priority_level === "Low"
                                ? "#81C784"
                                : item.priority_level === "Medium"
                                ? "#FFCC80"
                                : item.priority_level === "High"
                                ? "#E57373"
                                : "#BDBDBD"
                            }
                          >
                            <MaterialTypography
                              variant="caption"
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "white",
                              }}
                            >
                              {item.priority_level}
                            </MaterialTypography>
                          </Box>
                          <Box
                            width="auto"
                            height="20px"
                            p={1}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius="4px"
                            bgcolor={
                              item.status === "Not Started"
                                ? "#9E9E9E"
                                : item.status === "In Progress"
                                ? "#42A5F5"
                                : item.status === "Completed"
                                ? "#66BB6A"
                                : item.status === "Hold"
                                ? "#FFB74D"
                                : item.status === "Abort"
                                ? "#EF5350"
                                : "#BDBDBD"
                            }
                          >
                            <MaterialTypography
                              variant="caption"
                              sx={{
                                fontSize: "10px",
                                fontWeight: 500,
                                color: "white",
                              }}
                            >
                              {item.status}
                            </MaterialTypography>
                          </Box>
                        </Stack>
                      </Grid>

                      <Grid size={{ xs: 6 }}>
                        <Stack direction="row" spacing={0} alignItems="center">
                          <PersonRoundedIcon
                            sx={{
                              fontSize: "1.2rem",
                              color: "#1976d2",
                              mr: 0.5,
                            }}
                          />
                          <MaterialTypography variant="caption" color="text">
                            {item.assignee_name}
                          </MaterialTypography>
                        </Stack>
                      </Grid>

                      <Grid
                        size={{ xs: 6 }}
                        display="flex"
                        justifyContent="flex-end"
                      >
                        <Stack direction="row" spacing={0} alignItems="center">
                          <IconButton onClick={() => onComment(item.id, item)}>
                            <FaRegComments
                              style={{ fontSize: "18px", color: "gray" }}
                            />
                          </IconButton>
                          <IconButton onClick={(e) => handleClick(e, item)}>
                            <CiCircleMore
                              style={{ fontSize: "18px", color: "gray" }}
                            />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                          >
                            <MenuItem
                              onClick={() => handleView(subtaskdata)}
                              sx={{ fontSize: "13px", py: 0.5, px: 1.5 }}
                            >
                              View
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleEdit(subtaskdata)}
                              sx={{ fontSize: "13px", py: 0.5, px: 1.5 }}
                            >
                              Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleDelete(subtaskdata)}
                              style={{ color: "#e7625f" }}
                              sx={{ fontSize: "13px", py: 0.5, px: 1.5 }}
                            >
                              Delete
                            </MenuItem>
                          </Menu>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          mt={1}
          mb={2}
        >
          <img
            src={noTask}
            alt="No Sub-task Found"
            style={{ width: "50px", height: "50px", opacity: 0.6 }}
          />
          <MaterialTypography
            variant="caption"
            color="text"
            fontWeight="bold"
            mt={1}
          >
            Looks like this task doesn’t have any sub-tasks yet.
          </MaterialTypography>
          <MaterialTypography
            variant="caption"
            color="text"
            sx={{ fontSize: "10px", mt: "5px" }}
          >
            Add by pressing the "Add" button in the top right corner
          </MaterialTypography>
        </Box>
      )}

      <Grid container spacing={0} mb={1} mt={1}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Details data={data} />
        </Grid>
      </Grid>

      <Grid container spacing={0} mt={2}>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <ActivitySection taskData={taskData} />
        </Grid>
      </Grid>

      {/* <Dialog
        open={open}
        onClose={handleCloseDialog}
        PaperProps={{
          sx: {
            width: "35%",
            height: "auto",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialTypography variant="h6" color="dark" fontWeight="bold">
            Sub task comments
          </MaterialTypography>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {comments.map((c, index) => (
              <Box key={index} display="flex" gap={1}>
                <Avatar sx={{ width: 30, height: 30 }}>
                  {c.name.charAt(0)}
                </Avatar>
                <Box>
                  <MaterialTypography variant="subtitle2" color="dark">
                    {c.name}
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    {c.comment}
                  </MaterialTypography>
                </Box>
              </Box>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{ borderTop: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialInput
            label="Add Comment"
            placeholder="Type your comment here"
            multiline
            rows={2}
            fullWidth
            variant="outlined"
            size="small"
            sx={{ marginRight: 0 }}
          />
          <IconButton>
            <IoSend style={{ fontSize: "20px", color: "#1976d2" }} />
          </IconButton>
        </DialogActions>
      </Dialog> */}

      <Dialog
        open={subtaskDialogOpen}
        onClose={handleCloseSubtaskDialog}
        PaperProps={{
          sx: {
            width: "50%",
            height: "auto",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialTypography variant="h6" color="dark" fontWeight="bold">
            Add new sub task
          </MaterialTypography>
        </DialogTitle>
        <DialogContent dividers>
          <SubtaskAddForm
            subTask={subTask}
            setSubTask={setSubTask}
            data={data}
            editdata={editdata}
            view={view}
            stakeholderdata={stakeholderdata}
          />
        </DialogContent>
        <DialogActions
          sx={{ borderTop: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialButton
            varinat="contained"
            size="samll"
            onClick={handleCloseSubtaskDialog}
          >
            Cancel
          </MaterialButton>
          {view === false && (
            <MaterialButton
              variant="contained"
              size="small"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddSubtask}
            >
              Submit
            </MaterialButton>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={opencomment}
        onClose={handleCloseDialogComment}
        PaperProps={{
          sx: {
            width: "50%",
            height: "auto",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialTypography
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            variant="h6"
            color="dark"
            fontWeight="bold"
          >
            Task comments{" "}
            <CloseIcon
              onClick={handleCloseDialogComment}
              sx={{ color: "#000", fontSize: "20px", cursor: "pointer" }}
            />
          </MaterialTypography>
        </DialogTitle>
        <DialogContent dividers>
          {comments.length > 0 && (
            // maxHeight: "400px", overflowY: "auto",
            <Box sx={{ pr: 1 }}>
              <Stack spacing={2}>
                {comments.map((c, index) => (
                  <Box key={index}>
                    {/* Main Comment */}
                    <Box display="flex" gap={1} alignItems="flex-start">
                      <Avatar
                        sx={{
                          width: 30,
                          height: 30,
                          "& img": {
                            height: "100%",
                            objectFit: "cover",
                          },
                        }}
                        src={
                          c.commented_by_profile
                            ? BASE_URL + c.commented_by_profile
                            : undefined
                        }
                      >
                        {!c.commented_by_profile &&
                          c.commented_by_username?.charAt(0)}
                      </Avatar>
                      <Box>
                        <MaterialTypography
                          variant="subtitle2"
                          color="dark"
                          sx={{ lineHeight: "1.2" }}
                        >
                          {c.commented_by_username}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="caption"
                          color="gray"
                          sx={{ fontSize: "0.7rem", lineHeight: "1.2" }}
                        >
                          {new Date(c.created_at).toLocaleString()}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="caption"
                          color="text"
                          sx={{ display: "block", mt: 0.5 }}
                        >
                          {renderText(
                            c.comment_text,
                            expandedComments[index],
                            () => toggleCommentExpand(index)
                          )}
                        </MaterialTypography>
                      </Box>
                    </Box>

                    {/* Replies */}
                    <Stack spacing={1} pl={5} mt={1}>
                      {c.replies?.map((reply, replyIndex) => {
                        const replyKey = `${index}-${replyIndex}`;
                        return (
                          <Box
                            key={replyIndex}
                            display="flex"
                            gap={1}
                            alignItems="flex-start"
                          >
                            <Avatar
                              sx={{
                                width: 30,
                                height: 30,
                                "& img": {
                                  height: "100%",
                                  objectFit: "cover",
                                },
                              }}
                              src={
                                reply.commented_by_profile
                                  ? BASE_URL + reply.commented_by_profile
                                  : undefined
                              }
                            >
                              {!reply.commented_by_profile &&
                                reply.commented_by_username?.charAt(0)}
                            </Avatar>
                            <Box>
                              <MaterialTypography
                                variant="subtitle2"
                                color="dark"
                                sx={{ lineHeight: "1.2" }}
                              >
                                {reply.commented_by_username}
                              </MaterialTypography>
                              <MaterialTypography
                                variant="caption"
                                color="gray"
                                sx={{ fontSize: "0.7rem", lineHeight: "1.2" }}
                              >
                                {new Date(reply.created_at).toLocaleString()}
                              </MaterialTypography>
                              <MaterialTypography
                                variant="caption"
                                color="text"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                {renderText(
                                  reply.comment_text,
                                  expandedReplies[replyKey],
                                  () => toggleReplyExpand(index, replyIndex)
                                )}
                              </MaterialTypography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Stack>
                  </Box>
                ))}
              </Stack>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{ borderTop: "1px solid #ccc", padding: "8px 16px" }}
        >
          <MaterialInput
            label="Add Comment"
            placeholder="Type your comment here"
            multiline
            rows={2}
            fullWidth
            variant="outlined"
            value={commentsinput}
            onChange={handleComment}
            size="small"
            sx={{ marginRight: 0 }}
            inputProps={{ maxLength: 250 }}
          />
          <IconButton
            onClick={sendComment}
            style={{ opacity: commentsinput == "" ? 0.5 : 1 }}
            disabled={commentsinput == ""}
          >
            <IoSend style={{ fontSize: "20px", color: "#1976d2" }} />
          </IconButton>
        </DialogActions>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 0.5, paddingLeft: 3, mb: 1 }}
        >
          Note: 250 characters allowed
        </Typography>
      </Dialog>
    </>
  );
};

export default TaskView;
